
















import {Component, Vue, Watch} from 'vue-property-decorator';
import { debounce } from 'lodash';
import {syncChatwootUser} from '@/services/utils/chatwoot';
import { getIntercomBootPayload } from '@/services/utils/support-widget';
/*SG
  # Layout: 📰 Content
  `views/layout/content.vue`
  View for main application content.

  #### views:
  1. Router view
  2. Notifications through $toasted
  3. Intercom trough $intercom


  #### global events:
  - error-message
  - success-message
  - warning-message
  - bug-message

*/
@Component
export default class Content extends Vue {
  get reportTablePaths() {
    return ['app.report', 'app.sixth_sense', 'app.conversions', 'app.postbacks', 'app.errors', 'app.live-clicks', 'app.live-visits'];
  }

  get isHaveReportTable() {
    return this.reportTablePaths.includes(this.$route.name);
  }

  mounted() {
    if(!!this.$store.state.isAuthenticated && !!this.$store.state.isAuthorized) {
      if(this.$FF.chatwoot?.enabled){
        void syncChatwootUser(this.$store.state.user);
      } else {
        this.$intercom?.boot(getIntercomBootPayload(this.$store.state.user));

        this.$intercom?.hide();
      }
    }
  }

}
